module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-07-dfd1459d1a74e209e944ac98f024000a.svg";